module.exports = __webpack_public_path__ + "static/media/user_green.e1ae90fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user_green.svg
// module id = 801
// module chunks = 0